import users from './users'
import projects from './projects'
export default {
    users,
    projects
}
